(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('PollService', PollService);

  PollService.$inject = ['$resource'];

  function PollService ($resource) {
    return $resource(apiUrl + '/polls/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      sendPoll: { url: apiUrl + '/polls/send/:user_id', method: 'POST', params: {}, isArray: false }

    });
  }
})();
